import { CookiesHelper } from "../../utility/cookies";

if (document.querySelector('.roboyo-unlock')) {

  if (CookiesHelper.readCookie('roboyo_unlock_subscribed')) {
    dismissPaywall();
  } else {
    const appearance = document.querySelector('.roboyo-unlock').getAttribute('data-appearance');
    let timer = document.querySelector('.roboyo-unlock').getAttribute('data-timer');
    const intersectingAnchor = document.querySelector('.roboyo-unlock').getAttribute('data-anchor');

    console.log('Appearance: ', appearance)

    if (appearance === 'disabled') {
      dismissPaywall();
    } else if (appearance === 'intersection') {
      let lastScrollY = window.scrollY;
      let hasTriggered = false;      

      const target = document.querySelector('#' + intersectingAnchor)

      // If the target isn't on the page fall back to a timer
      if (!target) {
        setTimeout(() => {
          showPaywall()
        }, 3000)
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          const scrollingDown = window.scrollY > lastScrollY
          lastScrollY = window.scrollY 

          if (!entry.isIntersecting && scrollingDown && !hasTriggered) {
            showPaywall();
            hasTriggered = true
            observer.unobserve(entry.target)
          }
        }, 
        {
          root: null,
          threshold: 0
        }
      )

      observer.observe(target)
    } else  {
      if (!timer) {
        timer = 3
      }
      setTimeout(() => {
        showPaywall()
      }, parseInt(timer) * 1000)
    }
  }

}

document.addEventListener('click', (e) => {
  if (!e.target.matches('.js-unlock__button')) return false 

  document.querySelector('.roboyo-unlock__dialog').classList.remove('roboyo-unlock__dialog--closed')
  document.querySelector('.js-unlock__form').classList.remove('roboyo-unlock--hide');
  document.querySelector('.js-unlock__button').classList.add('roboyo-unlock--hide');
  document.querySelector('.js-unlock__terms').classList.remove('roboyo-unlock--hide');
})

jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
  CookiesHelper.createCookie('roboyo_unlock_subscribed', true, 30);

  dismissPaywall();
})

function showPaywall() {
  // window.scrollTo({top: 0, behavior: 'smooth'})
  document.querySelector('.roboyo-unlock').classList.remove('roboyo-unlock--hide');

  const scrollY = window.scrollY || document.documentElement.scrollTop 

  setTimeout(() => {
    document.querySelector('.case_study-template-default').classList.add('roboyoX245');

    document.querySelector('.case_study-template-default').style.top = `-${scrollY}px`

    document.querySelector('.roboyo-unlock').classList.add('roboyo-unlock--show');
  }, 500)
}

function dismissPaywall() {
  document.querySelector('.roboyo-unlock').remove();

  const scrollY = -parseInt(document.querySelector('.case_study-template-default').style.top || '0');

  document.querySelector('.case_study-template-default').style.top = ''

  console.log('Setting scroll: ', scrollY)
  document.querySelector('.case_study-template-default').classList.remove('roboyoX245');
  
  const previousScrollBehavior = document.documentElement.style.scrollBehavior;
  document.documentElement.style.scrollBehavior = 'auto';
  window.scrollTo(0, scrollY);
  document.documentElement.style.scrollBehavior = previousScrollBehavior;
}